import { configureStore } from "@reduxjs/toolkit";
import rootReducer from "./reducer";
import initialState from "./initial.value";

// eslint-disable-next-line no-undef
const isDevelopment = process.env.NODE_ENV !== "production";

const store = configureStore({
  reducer: rootReducer,
  preloadedState: initialState,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      immutableCheck: isDevelopment
        ? {
            // Estado grandes como a arvore de acesso .
            ignoredPaths: ["access.acessos"],
            warnAfter: 256,
          }
        : false,
      serializableCheck: isDevelopment
        ? {
            ignoredPaths: ["access.acessos"],
            ignoredActions: ["SET_ACESSOS"],
            warnAfter: 256,
          }
        : false,
    }),
});

export default store;
